import { useEffect, useRef, useState } from 'react';
import useModalState, { ModalState } from '@sdk/components/ui/modal/useModalState';
import { ModalConfig } from '@sdk/components/ui/modal/modal.types';

/* Proxy state that gives ability to be opened with property change in angular */

export function useAngularModalState(
  isOpen: boolean,
  onClose: () => void,
  config?: ModalConfig
): ModalState {
  const modalState = useModalState(config);
  // using isOpen as default prevents calling modalState.open in the first render
  const isOpenAngularRef = useRef(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (isOpenAngularRef.current !== isOpen) {
      isOpen ? modalState.open() : modalState.close();
      setIsInitialized(true);
    }

    isOpenAngularRef.current = isOpen;
  }, [isOpen, modalState]);

  useEffect(() => {
    // we don't want to call onClose before modal is opened for the first time
    if (isInitialized && !modalState.isVisible) {
      onClose?.();
    }
  }, [modalState.isVisible, onClose, isInitialized]);

  return modalState;
}
